<template>
  <div>
    <h1>紅包</h1>
    <section class="member_coupon">
      <div class="tabs">
        <ul class="tabsNav cf">
          <li>
            <a  href="#tab1">可自用<i>{{this.getTotal}}</i></a>
          </li>
          <li>
            <a  href="#tab2">可贈送<i>{{this.giftTotal}}</i></a>
          </li>
        </ul>

        <div class="content">
          <div  class="tab1"  id="tab1">
            <div class="hdr">
              <!-- <label for="addcoupon" class="inp error"> -->
              <label v-if="this.$store.state.couponState == ''" for="addcoupon" class="inp ">
                <input v-model="inputCouponValue" type="text" placeholder=" " id="addcoupon">
                <span class="label">輸入您的序號（大小寫皆可）</span>
                <span class="border"></span>
                <span class="errorText">{{this.$store.state.couponState}}</span>
              </label>

              <label v-else for="addcoupon" class="inp error">
                <input v-model="inputCouponValue" type="text" placeholder=" " id="addcoupon">
                <span class="label">輸入您的序號（大小寫皆可）</span>
                <span class="border"></span>
                <span class="errorText">{{this.$store.state.couponState}}</span>
              </label>
              <button @click="inputCoupon()"  type="submit" class="btnStyle_2" id="submit_addcoupon">
                <span data-original-title="確定">確定</span>
              </button>
              <div class="toast">
                <div class="wrap">{{this.toastMsg}}</div>
              </div>
            </div>
            <section class="conditionSection cf">
              <div class="col-l">共<i>{{this.getTotal}}</i>張</div>
            </section>

            <ul class="cf">
              <li class="coupon_item"  v-for = "couponData in getCoupons" :key="couponData.id">
                <div class="hd">
                  <!-- <h2>*所有課程皆可兌換</h2> -->
                  <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                  <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                  <b v-if="couponData.coupon_extension == null">{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <b  class="deletedate" v-else>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <b v-if="couponData.coupon_extension != null" class="newdate">{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_extension).toLocaleDateString()}}</b>
                  <div class="info compaign">
                    <i>活動</i>
                    <strong>{{couponData.title}}</strong>
                  </div>
                  <div class="info saved">
                    <i>存入</i>
                    <strong>{{new Date(couponData.enter_date).toLocaleDateString()}}</strong>
                  </div>
                </div>
                <div class="ft cf">
                  <div class="points">
                    <i>可折抵</i>
                    <strong v-if="couponData.type == 3">全部折抵</strong>
                    <strong  v-else-if="couponData.type == 4">全部折抵</strong>
                    <strong  v-else>{{couponData.points}}點</strong>
                  </div>
                  <!-- <div class="directLink"><b>檢視課程</b></div> -->
                </div>
                <!-- <router-link to="/channel/list"><a class="fullLink" href=""/></router-link> -->
              </li>
            </ul>

            <h3 class="title_line"><span>已使用</span></h3>
            <ul class="cf">
              <li class="coupon_item used"  v-for = "couponData in usedGetCoupons" :key="couponData.id">
                <div class="hd">
                  <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                  <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                  <b>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <div class="info compaign">
                    <i>活動</i>
                    <strong>{{couponData.title}}</strong>
                  </div>
                  <div class="info saved">
                    <i>存入</i>
                    <strong>{{new Date(couponData.enter_date).toLocaleDateString()}}</strong>
                  </div>
                </div>
                <div class="ft cf" v-if="couponData.type !== 7">
                  <div class="points">
                    <i>可折抵</i>
                    <strong v-if="couponData.type == 3">全部折抵</strong>
                    <strong v-else-if="couponData.type == 4">全部折抵</strong>
                    <strong v-else>{{couponData.points}}點</strong>
                  </div>
                  <div class="status">{{new Date(couponData.point_consume.created_at).toLocaleDateString()}} 已使用</div>
                </div>
              </li>
            </ul>

            <h3 class="title_line"><span>已過期</span></h3>
            <ul class="cf">
              <li class="coupon_item used expired"  v-for = "couponData in expiredGetCoupons" :key="couponData.id">
                <div class="hd">
                  <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                  <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                  <b>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <div class="info compaign">
                    <i>活動</i>
                    <strong>{{couponData.title}}</strong>
                  </div>
                  <div class="info saved">
                    <i>存入</i>
                    <strong>{{new Date(couponData.enter_date).toLocaleDateString()}}</strong>
                  </div>
                </div>
                <div class="ft cf" v-if="couponData.type !== 7">
                  <div class="points">
                    <i>可折抵</i>
                    <strong v-if="couponData.type == 3">全部折抵</strong>
                    <strong v-else-if="couponData.type == 4">全部折抵</strong>
                    <strong v-else>{{couponData.points}}點</strong>
                  </div>
                  <div class="status">已過期</div>
                  <!-- <div class="status">{{new Date(couponData.point_consume.created_at).toLocaleDateString()}} 已使用</div> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="tab2"  id="tab2">
            <section class="conditionSection cf">
              <div class="col-l">共<i>{{this.giftTotal}}</i>張</div>
            </section>

            <ul class="cf">
              <li class="coupon_item"  v-for = "couponData in giftCoupons" :key="couponData.id">
                <div class="hd">
                  <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                  <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                  <b v-if="couponData.coupon_extension == null">{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <b  class="deletedate" v-else>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <b v-if="couponData.coupon_extension != null" class="newdate">{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_extension).toLocaleDateString()}}</b>
                  <div class="info saved">
                    <i>存入</i>
                    <strong>{{new Date(couponData.coupon_start).toLocaleDateString()}}</strong>
                  </div>
                </div>
                <!-- <div class="ft cf">
                    <div class="points">
                        <i>可折抵</i>
                            <strong v-if="couponData.type == 3">全部折抵</strong>
                            <strong  v-else-if="couponData.type == 4">全部折抵</strong>
                            <strong  v-else>{{couponData.points}}點</strong>
                    </div> -->
                        <!-- <div class="directLink"><b>檢視課程</b></div> -->
                <!-- </div> -->
                <!-- <router-link to="/channel/list"><a class="fullLink" href=""/></router-link> -->
              </li>
            </ul>

            <h3 class="title_line"><span>已贈送</span></h3>
            <ul class="cf">
              <li class="coupon_item used"  v-for = "couponData in usedGiftCoupons" :key="couponData.id">
                <div class="hd">
                  <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                  <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                  <b>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <div class="info saved">
                    <i>存入</i>
                    <strong>{{new Date(couponData.coupon_start).toLocaleDateString()}}</strong>
                  </div>
                </div>
              </li>
            </ul>

            <h3 class="title_line"><span>已過期</span></h3>
            <ul class="cf">
              <li class="coupon_item used expired"  v-for = "couponData in expiredGiftCoupons" :key="couponData.id">
                <div class="hd">
                  <h2 v-if="couponData.channel == null">*所有課程皆可兌換</h2>
                  <h2 v-else>可兌換：{{couponData.channel.title}}</h2>
                  <b>{{new Date(couponData.coupon_start).toLocaleDateString()}} - {{new Date(couponData.coupon_end).toLocaleDateString()}}</b>
                  <div class="info saved">
                    <i>存入</i>
                    <strong>{{new Date(couponData.coupon_start).toLocaleDateString()}}</strong>
                  </div>
                </div>
                <!-- <div class="ft cf">
                    <div class="points">
                        <i>可折抵</i>
                        <strong v-if="couponData.type == 3">全部折抵</strong>
                        <strong v-else-if="couponData.type == 4">全部折抵</strong>
                        <strong v-else>{{couponData.points}}點</strong>
                    </div>
                    <div class="status">已過期</div> -->
                    <!-- <div class="status">{{new Date(couponData.point_consume.created_at).toLocaleDateString()}} 已使用</div> -->
                <!-- </div> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import firebase from 'firebase/app'
import 'firebase/auth'
import { mapGetters } from 'vuex'
// import { getCoupon } from '@/assets/js/api/api.js'

export default {
  name: 'myCoupon',
  metaInfo () {
    return {
      title: '紅包 | 我的 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '紅包 | 我的 | 一刻鯨選' },
        { property: 'og:site_name', content: '紅包 | 我的 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '登入後，即可查看帳戶所有資訊。' }

      ]
    }
  },
  data () {
    return {
      allCouponDatas: [],
      getCoupons: [], // 未使用紅包
      usedGetCoupons: [], // 使用過紅包
      expiredGetCoupons: [], // 已過期紅包
      giftCoupons: [], // 未使用贈送券
      usedGiftCoupons: [], // 已贈送贈課券
      expiredGiftCoupons: [], // 過期贈送券
      newCouponDatas: [],
      inputCouponValue: '',
      isCoupon: false,
      toastMsg: '成功取得紅包'

    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    getTotal: function () {
      return this.getCoupons.length + this.usedGetCoupons.length + this.expiredGetCoupons.length
    },
    giftTotal: function () {
      return this.giftCoupons.length + this.usedGiftCoupons.length + this.expiredGiftCoupons.length
    }
  },
  methods: {
    getAllCoupon () {
      this.axios.get(this.$store.getters.baseURL + 'coupons', { headers: { Authorization: `Bearer ${localStorage.getItem('credentialToken')}` } })
        .then(response => {
          if (this.allCouponDatas !== []) {
            this.getCoupons = []
            this.usedGetCoupons = []
            this.expiredGetCoupons = []
            this.giftCoupons = []
            this.usedGiftCoupons = []
            this.expiredGiftCoupons = []
          }
          this.allCouponDatas = response.data
          this.giftFilter(this.allCouponDatas)
        })
        .catch(error => console.log('log:' + error))
    },
    convertUTCTimeToLocalTime: function (UTCDateString) {
      if (!UTCDateString) {
        return '-'
      }
      function formatFunc (str) { // 格式化显示
        return str > 9 ? str : '0' + str
      }
      var date2 = new Date(UTCDateString) // 这步是关键
      var year = date2.getFullYear()
      var mon = formatFunc(date2.getMonth() + 1)
      var day = formatFunc(date2.getDate())
      var hour = date2.getHours()
      // var noon = hour >= 12 ? 'PM' : 'AM';
      // hour = hour>=12?hour-12:hour;
      // hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes())
      var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min
      return dateStr
    },
    signOut () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('authLogout').then(() => {
            this.$router.push('/')
            this.$store.commit('savePath', '/index')
          })
          localStorage.removeItem('user-info')
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    inputCoupon () {
      this.$store.commit('couponState', '')
      this.axios.patch(
        this.$store.getters.baseURL + 'coupons/' + this.inputCouponValue,
        { number: this.inputCouponValue },
        { headers: { Authorization: `Bearer ${localStorage.getItem('credentialToken')}` } }
      ).then(response => {
        if (response.data != null) {
          // eslint-disable-next-line eqeqeq
          if (this.$store.state.couponState == '202') {
            this.$store.commit('couponState', '已取得紅包，請至 App 兌換課程')
          } else {
            // eslint-disable-next-line eqeqeq
            if (this.$store.state.couponState == '203') {
              this.toastMsg = '您已成功兌換此課程'
            // eslint-disable-next-line eqeqeq
            } else if (this.$store.state.couponState == '200') {
              this.toastMsg = '成功取得優惠券'
            } else {
              this.toastMsg = '成功取得紅包'
            }
            this.$store.commit('couponState', '')
            $('.toast').slideDown()
            window.setTimeout(function () {
              $('.toast').slideUp()
              //  location.reload()
            }, 2500)
            this.getAllCoupon()
          }
        }
      })
        .catch(error => console.log('log:' + error)
        )
      this.$store.commit('couponState', '')
    },
    // 分出可自用和可贈送
    giftFilter (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].type === 7 && arr[i].gift_customer.account === this.userInfo.account) {
          this.giftExpiredFilter(arr[i])
        } else {
          this.getExpiredFilter(arr[i])
        }
      }
    },
    // 分出未過期、已兌換、已過期自用紅包
    getExpiredFilter (e) {
      // 判斷是否過期
      if (this.expiredFilter(e)) {
        this.expiredGetCoupons.push(e)
      } else {
        // 判斷是否使用
        if (e.point_consume !== null) {
          this.usedGetCoupons.push(e)
        } else {
          this.getCoupons.push(e)
        }
      }
    },
    // 分出未過期、已贈出、已過期贈課券
    giftExpiredFilter (e) {
      // 判斷是否過期
      if (this.expiredFilter(e)) {
        this.expiredGiftCoupons.push(e)
        // 判斷是否自用加進可自用
        if (e.receive_customer !== null && e.receive_customer.account === this.userInfo.account) {
          this.expiredGetCoupons.push(e)
        }
      } else {
        // 判斷是否使用
        if (e.receive_customer !== null) {
          this.usedGiftCoupons.push(e)
          // 判斷是否自用加進可自用
          if (e.receive_customer.account === this.userInfo.account) {
            this.usedGetCoupons.push(e)
          }
        } else {
          this.giftCoupons.push(e)
        }
      }
    },
    // 判斷是否過期
    expiredFilter (e) {
      const today = Date.parse(new Date().toLocaleDateString()).valueOf()
      const couponDay = Date.parse(new Date(this.convertUTCTimeToLocalTime(e.coupon_end)).toLocaleDateString()).valueOf()

      return today > couponDay && e.coupon_extension == null
    }
  },
  mounted () {
    // //Tabs functionality
    // Firstly hide all content divs
    // $('.content > div').hide();
    // Then show the first content div
    // $('.content > div:first').show();
    // Add active class to the first tab link
    $('.tabsNav li:first').addClass('active')
    // Functionality when a tab is clicked
    $('.tabsNav li a').click(function () {
      // Firstly remove the current active class
      $('.tabsNav li').removeClass('active')
      // Apply active class to the parent(li) of the link tag
      $(this).parent().addClass('active')
      // Set currentTab to this link
      var currentTab = $(this).attr('href')
      // Hide away all tabs
      $('.tab1').hide()
      $('.tab2').hide()
      // show the current tab
      $(currentTab).show()
      // Stop default link action from happening
      return false
    })
    $('.toast').hide()
    // toast
    //     var toast = $(".toast");
    //     toast.hide();
    //    $("#submit_addcoupon").click(function(e) {
    //       // if(this.isCoupon){
    //             e.preventDefault();
    //              $(".toast").slideDown();
    //             window.setTimeout(function() {
    //                  $(".toast").slideUp();
    //             }, 2500);
    //       // }
    //     });
  },

  created () {
    this.getAllCoupon()
  }
}
</script>

<style>

@import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyCoupon.vue